import React from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import Address from "../searchresults/Address";
import { getDate } from "../common/DisplayDate";
import VehicleDetails from "./Platinum/VehicleDetails";
import getPersonName from "../common/Name";

const personalDetails = (record) => {
  const persDetails = {
    firstName: "",
    lastName: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    addressNode: undefined,
  };
  let node = _.get(record, "matchedParty[0]");
  if (node === undefined)
    node = _.get(record, "owners[0].owner[0].ownerInfo[0]");
  if (node === undefined)
    node = _.get(record, "lessees[0].lessee[0].lesseeInfo[0]");
  if (node === undefined)
    node = _.get(record, "registrants[0].registrant[0].registrantInfo[0]");
  if (node !== undefined) {
    persDetails.firstName = _.get(node, "name[0].first[0]._", "");
    persDetails.lastName = _.get(node, "name[0].last[0]._", "");
    persDetails.street = `${_.get(
      node,
      "address[0].streetNumber[0]._",
      ""
    )} ${_.get(node, "address[0].streetName[0]._", "")} ${_.get(
      node,
      "address[0].streetSuffix[0]._",
      ""
    )}`;
    persDetails.city = _.get(node, "address[0].city[0]._", "");
    persDetails.state = _.get(node, "address[0].state[0]._", "");
    persDetails.zip = _.get(node, "address[0].zip[0]._", "");
    persDetails.addressNode = _.get(node, "address[0]");
  }
  return persDetails;
};

const getFullName = (record) => {
  let fullName = _.get(record, "matchedParty[0].originName[0]._");
  if (
    fullName === undefined &&
    _.get(record, "registrants[0].registrant[0].registrantInfo[0].name[0]") !==
      undefined
  ) {
    fullName = `${_.get(
      record,
      "registrants[0].registrant[0].registrantInfo[0].name[0].first[0]._",
      ""
    )} ${_.get(
      record,
      "registrants[0].registrant[0].registrantInfo[0].name[0].middle[0]._",
      ""
    )} ${_.get(
      record,
      "registrants[0].registrant[0].registrantInfo[0].name[0].last[0]._",
      ""
    )}`;
  }
  if (fullName === undefined) {
    fullName = `${_.get(
      record,
      "lessees[0].lessee[0].lesseeInfo[0].name[0].first[0]._",
      ""
    )} ${_.get(
      record,
      "lessees[0].lessee[0].lesseeInfo[0].name[0].middle[0]._",
      ""
    )} ${_.get(
      record,
      "lessees[0].lessee[0].lesseeInfo[0].name[0].last[0]._",
      ""
    )}`;
  }
  return fullName;
};

const addVehicleInfoRows = (
  props,
  record,
  rows,
  index,
  showAdditionalDetails = false
) => {
  const innerRows = [];
  const year = _.get(record, "vehicleInfo[0].yearMake[0]._", "");
  const make = _.get(record, "vehicleInfo[0].make[0]._", "");
  const model = _.get(record, "vehicleInfo[0].model[0]._", "");
  const color = _.get(record, "vehicleInfo[0].series[0]._", "");
  const vinNumber = _.get(record, "vehicleInfo[0].VIN[0]._", "");
  const plate = _.get(
    record,
    "registrants[0].registrant[0].registrationInfo[0].trueLicensePlate[0]._",
    ""
  );

  const fullName = getFullName(record);
  const persDetails = personalDetails(record);
  const expires = [];
  const expireNodes = _.get(
    record,
    "registrants[0].registrant[0].registrationInfo[0].latestExpirationDate"
  );
  if (expireNodes !== undefined) {
    _.forEach(expireNodes, (expNode) => {
      expires.push(getDate(expNode));
    });
  }
  innerRows.push(
    <Table.Row key={`veh_name_row_${index}`}>
      <Table.Cell width={2}>Name:</Table.Cell>
      <Table.Cell width={8}>
        {persDetails.firstName !== ""
          ? getPersonName(
              persDetails.firstName,
              "",
              persDetails.lastName,
              props
            )
          : fullName}
      </Table.Cell>
      <Table.Cell width={2}>Year/Make:</Table.Cell>
      <Table.Cell width={4}>{`${year} ${make} ${model} ${color}`}</Table.Cell>
    </Table.Row>
  );
  innerRows.push(
    <Table.Row key={`veh_add_row_${index}`}>
      <Table.Cell width={2}>Address:</Table.Cell>
      <Table.Cell width={8}>
        <Address
          addressNode={persDetails.addressNode}
          {...props}
          hideHomeValue
          hideHomeIncome
        />
      </Table.Cell>
      <Table.Cell width={2}>VIN: </Table.Cell>
      <Table.Cell width={4}>{vinNumber}</Table.Cell>
    </Table.Row>
  );
  if (plate !== "") {
    innerRows.push(
      <Table.Row key={`veh_plate_row_${index}`}>
        <Table.Cell width={2}>Plate:</Table.Cell>
        <Table.Cell width={8}>{plate}</Table.Cell>
        <Table.Cell width={2}>Expires:</Table.Cell>
        <Table.Cell width={4}>{expires}</Table.Cell>
      </Table.Row>
    );
  }
  if (showAdditionalDetails) {
    innerRows.push(
      <Table.Row key={`veh_detail_row_${index}`}>
        <Table.Cell colSpan={4}>
          <VehicleDetails record={record} detailIndex={index} {...props} />
        </Table.Cell>
      </Table.Row>
    );
  }
  rows.push(
    <Table.Row
      key={`veh_strip_table_row_${index}`}
      className={
        rows.length % 2 === 1
          ? "table-no-padding table-row-odd-child"
          : "table-no-padding"
      }
    >
      <Table.Cell>
        <Table
          key={`veh_table_row_${index}`}
          className="background-color-transparent"
        >
          <Table.Body>{innerRows}</Table.Body>
        </Table>
      </Table.Cell>
    </Table.Row>
  );
};

export default addVehicleInfoRows;



// WEBPACK FOOTER //
// ./src/components/reports/VehicleInfo.js